import { render, staticRenderFns } from "./order_form_detail.vue?vue&type=template&id=67d81401&scoped=true&"
import script from "./order_form_detail.vue?vue&type=script&lang=js&"
export * from "./order_form_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_form_detail.vue?vue&type=style&index=0&id=67d81401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d81401",
  null
  
)

export default component.exports